<template>
  <div class="kontrollersLogComp">

    <users-filters-comp v-show="showFilters" :showSliders="showFilters"/>
    <tbl-comp
      v-show="!showFilters"
      :model="this.$store.getters[`${this.moduleName}/getModel`]"
      :paging="true"
      :rowClick="rowClick"
      :moduleName="moduleName"
      :params="Object.assign(filters, params)"
      :searchInput="false"
      :filters="false"
      :searchPlaceholder="''"
    />

  </div>
</template>

<script>
export default {
  name: 'kontrollersLogComp',
  props: {
    params: {
      type: Object,
      default: function () { return {} }
    }
  },
  data: function () {
    return {
      show: false,
      moduleName: 'kontrollersLog',
      required: [
        'ID',
        'DT',
        'TS',
        'EVENT_NAME'
        // 'KRNUM',
        // 'SP',
        // 'NP'
      ]
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
  },
  components: {
  },
  computed: {
    filters: function () { return this.$store.getters[`${this.moduleName}/getFiltersQuery`] },
    showFilters: function () { return this.$store.getters[`${this.moduleName}/getShowFilters`] }
  },
  methods: {
    add () {
      // this.$store.dispatch(`${this.moduleName}/toAdd`);
    },
    rowClick (row) {
      // this.$store.dispatch(`${this.moduleName}/toUpdate`, {id: row.id});
    }
  }
}
</script>

<style scoped lang="scss">
</style>
